/**
 * Only the most recent request may apply its result.
 *
 * A screen that reloads when a filter changes can have two requests in
 * flight; if the older one answers last, it overwrites the newer answer and
 * the screen shows numbers for a filter that is no longer selected (review
 * 2026-09-22, item 10). Call `begin()` when a request starts; the function it
 * returns says whether that request is still the latest.
 */
import { useCallback, useRef } from 'react';

export function useLatestGuard(): () => () => boolean {
  const epoch = useRef(0);
  return useCallback(() => {
    epoch.current += 1;
    const mine = epoch.current;
    return () => mine === epoch.current;
  }, []);
}
